import React from 'react';

// Card for `kind: "tobin.plan"` (saveable-dining-plans). Renders a saved/embedded
// dining plan: a title plus one labeled section per step, each listing its
// resolved dishes (name — restaurant · price). Steps re-resolve against the live
// catalog on every open, so a saved plan shows current matches; an empty step
// keeps its slot with a `note` so the plan's shape stays legible.
//
// Expected structured shape:
//   { kind: "tobin.plan",
//     title: "Date night",
//     steps: [
//       { label: "Main",
//         dishes: [{ dish, restaurant, price_display?, cuisine? }, …] },
//       { label: "Dessert", dishes: [], note: "No current match" },
//     ] }
export default function TobinPlanCard({ structured }) {
  const steps = structured.steps || [];
  return (
    <div style={{
      marginBottom: '10px', padding: '14px', background: '#f8f9fa',
      borderRadius: '8px', border: '1px solid #e9ecef',
    }}>
      {structured.title && (
        <div style={{ fontSize: '1.05rem', fontWeight: 700, marginBottom: '12px' }}>
          {structured.title}
        </div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        {steps.map((step, i) => (
          <div key={i}>
            <div style={{
              fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.04em',
              textTransform: 'uppercase', color: '#0084ff', marginBottom: '6px',
            }}>
              {step.label || `Step ${i + 1}`}
            </div>
            {(step.dishes && step.dishes.length > 0) ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {step.dishes.map((d, j) => (
                  <div key={j} style={{
                    display: 'flex', justifyContent: 'space-between', gap: '10px',
                    padding: '8px 10px', background: '#ffffff',
                    borderRadius: '6px', border: '1px solid #f0f0f0',
                    fontSize: '0.85rem',
                  }}>
                    <div style={{ minWidth: 0 }}>
                      <span style={{ fontWeight: 700 }}>{d.dish}</span>
                      {d.restaurant && (
                        <span style={{ color: '#666' }}>{' — '}{d.restaurant}</span>
                      )}
                    </div>
                    {d.price_display && (
                      <span style={{ flex: '0 0 auto', fontWeight: 500, color: '#444' }}>
                        {d.price_display}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div style={{
                fontSize: '0.82rem', color: '#999', fontStyle: 'italic',
                padding: '4px 2px',
              }}>
                {step.note || 'No current match'}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
